import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { createQuoteRequestSchema, type CreateQuoteRequestInput } from "@smartvow/shared";
import { Button, Field, Input, Textarea } from "../../shared/ui/index.js";
import { useSubmitQuoteRequest } from "./quote.api.js";

export function QuoteForm({ onDone }: { onDone?: () => void }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<CreateQuoteRequestInput>({ resolver: zodResolver(createQuoteRequestSchema) });
  const submit = useSubmitQuoteRequest();

  if (submit.isSuccess) {
    return (
      <div className="py-4 text-center">
        <p className="text-sm text-emerald-700">Merci ! Nous revenons vers vous très vite. ✨</p>
        {onDone && (
          <Button variant="ghost" className="mt-3" onClick={onDone}>
            Fermer
          </Button>
        )}
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit((d) => submit.mutate(d))}
      className="flex flex-col gap-3"
    >
      <input type="text" tabIndex={-1} autoComplete="off" hidden {...register("website")} />
      <Field label="Votre nom" error={errors.contactName?.message}>
        <Input {...register("contactName")} />
      </Field>
      <Field label="Email" error={errors.email?.message}>
        <Input type="email" {...register("email")} />
      </Field>
      <div className="flex flex-col gap-3 sm:flex-row">
        <Field label="Téléphone (optionnel)" error={errors.phone?.message}>
          <Input {...register("phone")} />
        </Field>
        <Field label="Date de l'événement" error={errors.eventDate?.message}>
          <Input type="date" {...register("eventDate")} />
        </Field>
      </div>
      <Field label="Nombre d'invités (estimation)" error={errors.guestEstimate?.message}>
        <Input type="number" {...register("guestEstimate")} />
      </Field>
      <Field label="Message" error={errors.message?.message}>
        <Textarea rows={3} {...register("message")} />
      </Field>
      {submit.isError && (
        <p className="text-sm text-rose-600">Échec de l'envoi, merci de réessayer.</p>
      )}
      <Button type="submit" disabled={isSubmitting || submit.isPending}>
        {submit.isPending ? "Envoi…" : "Envoyer la demande"}
      </Button>
    </form>
  );
}
